import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, CssBaseline, Toolbar } from "@mui/material";
import CommonDrawer from "./CommonDrawer";
import Header from "./Header";
import Footer from "./Footer";
import LocalStorageUtil from "../utils/localStorageUtil";
import { storageKeys } from "../utils/constants";
import { useAlert } from "../contexts/AlertContext";
import { useProjectContext } from "../contexts/ProjectContext";
import { useTranslation } from "react-i18next";
import { useTitle } from "../contexts/TitleContext";
import { useDrawer } from "../contexts/DrawerContext";
import { useAppData } from "../contexts/AppDataContext";

const MainLayout: React.FC = () => {
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [open, setOpen] = useState(false);
  const { toggleDrawer } = useDrawer();
  const navigate = useNavigate();
  const { title, setTitle } = useTitle();
  const location = useLocation();
  const { clearProject } = useProjectContext();
  const name = LocalStorageUtil.getItem(storageKeys.userName, "");
  const { loadAppData } = useAppData();

  const handleDrawerState = () => {
    setOpen((prev) => !prev);
    toggleDrawer();
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    showAlert(t("login.Logout_success"), "success");
    clearProject();
    localStorage.removeItem("isAuthenticated");
    navigate("/login");
    LocalStorageUtil.clear();
  };
  useEffect(() => {
    // Update title based on current route
    const path = location.pathname;
    if (path === "/planning") {
      setTitle("Taak Planning");
    } else if (path.startsWith("/taskdetail")) {
      setTitle("Taak Details");
    } else if (path.startsWith("/task")) {
      setTitle("Taak");
    } else if (path.startsWith("/updatetaskdetail")) {
      setTitle("Taak Image Upload");
    } else if (path.startsWith("/safetyinstructions")) {
      setTitle("Veiligheidspagina");
    } else {
      setTitle("");
    }
  }, [location, setTitle]);

  // Ensure data is loaded when MainLayout mounts
  useEffect(() => {
    loadAppData();
  }, [loadAppData]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <CommonDrawer open={open} onClose={handleDrawerClose} />
      <Header
        onMenuClick={handleDrawerState}
        username={name}
        onLogout={handleLogout}
        open={open}
        title={title}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};

export default MainLayout;
